import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { config } from "config.js";
async function checkPermission(): Promise<any> {
  if (!("serviceWorker" in navigator)) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js", {
        updateViaCache: "none", // Bypass the cache
      });
    });
    // Service Worker isn't supported on this browser, disable or hide UI.
    throw new Error(
      "Service Worker isn't supported on this browser, disable or hide UI."
    );
  }
  if (!("Notification" in window)) {
    throw new Error("No support for notification API");
  }
  if (!("PushManager" in window)) {
    // Push isn't supported on this browser, disable or hide UI.
    throw new Error("Push isn't supported on this browser, disable or hide UI");
  }
}
async function serviceWorkerPermission(): Promise<any> {
  try {
    const registration = await navigator.serviceWorker.register(
      "/service-worker.js"
    );
    return registration;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
  }
}
// 1. Request permission
async function requestNotificationPermission(): Promise<NotificationPermission> {
  return Notification.requestPermission();
}
// store subcription in DB
async function saveSubcription(
  subscription: PushSubscription
): Promise<Response> {
  const token: any = localStorage.getItem("token");
  return fetch(BASE_URL + "notify/subscribe", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token, // Replace with your actual authentication token
    },
    body: JSON.stringify(subscription),
  });
}

// 2. Subscribe the client to push notifications
async function subscribeToPushNotifications(): Promise<PushSubscription | null> {
  const serviceWorkerRegistration = await navigator.serviceWorker.ready;
  console.log("serviceWorkerRegistration===", serviceWorkerRegistration);
  if (!serviceWorkerRegistration) return null;

  // Check if the user is already subscribed
  const existingSubscription =
    await serviceWorkerRegistration.pushManager.getSubscription();
  if (existingSubscription) {
    console.log(
      "User is already subscribed:",
      JSON.stringify(existingSubscription)
    );
    return existingSubscription;
  }

  // If not subscribed, subscribe the user
  try {
    const subscription = await serviceWorkerRegistration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: config.notificationPublicKey, // Replace with your actual application server key
    });
    console.log("subscription====", subscription);
    await saveSubcription(subscription);
    return subscription;
  } catch (error) {
    console.error("Failed to subscribe the user:", error);
    return null;
  }
}
// Example usage
async function PushNotificationsMain(userInfo: any) {
  try {
    console.log("userInfo====", userInfo);
    // check if the current browser actually supports push messaging
    const servicePermission = await checkPermission();
    console.log(servicePermission);
    // service register
    // 1. Request permission
    const permission = await requestNotificationPermission();
    console.log("Notification permission:", permission);
    // new Notification("Hey Manoj");
    if (permission !== "granted") {
      throw new Error("We weren't granted permission.");
    } else {
      // 2. Subscribe to push notifications
      const subscription = await subscribeToPushNotifications();
      console.log("subscription:", JSON.stringify(subscription));
      const reg: any = await serviceWorkerPermission();
      console.log(reg, "====reg");
      if (!subscription) {
        console.error("Push subscription failed.");
        return;
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

// Call main function
export { PushNotificationsMain };
